import { Serializer } from "survey-core";
import { localization } from "survey-creator-core";

/**
 * The condensed report and PDF force every field to left-align (see
 * `forceLeftInputTextAlignment` in createCondensedModel + the api-rs PDF
 * generator), which overrides SurveyJS's numeric-mask right-align. A designer
 * setting `inputTextAlignment` in the form builder therefore has no effect on
 * those views — so we disable the control and explain why in its help text,
 * rather than leave someone puzzling over alignment that "isn't working".
 */

const OVERRIDE_HELP =
  "Alignment in the condensed report and PDF is always forced to left, so this setting only affects the main data-entry form.";

let isRegistered = false;

export function registerInputTextAlignmentOverride() {
  if (isRegistered) return;

  ["text", "multipletextitem"].forEach((className) => {
    const property = Serializer.findProperty(className, "inputTextAlignment");
    if (property) property.readOnly = true;
  });

  localization.getLocale("").pehelp.inputTextAlignment = OVERRIDE_HELP;

  isRegistered = true;
}
